<template>
 <v-container class="px-0">
   <div class="wrapper">
    <v-row justify="center">
      <v-col class="text-center" sm="6" cols="12">
        <v-card>
          <v-card-text class="pb-0">
              <vue-circle-control-slider/>
          </v-card-text>
          <v-card-text class="pt-0">
            <v-list>
              <v-list-group color="purple">
                <template v-slot:activator>
                  <v-list-item-title>View props</v-list-item-title>
                </template>
                <v-list-item>
                  <editor v-model="contentDef" @init="editorInit" lang="html" theme="chrome" width="100%" height="50"></editor>
                </v-list-item>
              </v-list-group>
            </v-list>
              
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="text-center" sm="6" cols="12">
        <v-card>
          <v-card-text class="pb-0">
            <vue-circle-control-slider :startAngleOffset="0" progressColor="red" :value="25"/>
          </v-card-text>
          <v-card-text class="pt-0">
            <v-list>
              <v-list-group color="purple">
                <template v-slot:activator>
                  <v-list-item-title>View props</v-list-item-title>
                </template>
              <v-list-item>
                <editor v-model="content1" @init="editorInit" lang="html" theme="chrome" width="100%" height="100"></editor>
              </v-list-item>
              </v-list-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="text-center" sm="6" cols="12">
        <v-card>
          <v-card-text class="pb-0">
              <vue-circle-control-slider :value="25" dial sign="%" dialTextColor="red" :startAngleOffset="270" progressColor="green"  knobTextColor="red" knobBorderColor="orange" circleColor="black" />
          </v-card-text>
            <v-card-text class="pt-0">
            <v-list>
              <v-list-group color="purple">
                <template v-slot:activator>
                  <v-list-item-title>View props</v-list-item-title>
                </template>
              <v-list-item>
                <editor v-model="content2" @init="editorInit" lang="html" theme="chrome" width="100%" height="200"></editor>
              </v-list-item>
              </v-list-group>
            </v-list>
          </v-card-text>
      </v-card>
        </v-col>
      <v-col class="text-center" sm="6" cols="12">
        <v-card>
          <v-card-text class="pb-0">
            <vue-circle-control-slider offKnob :value="50" dial :progressWidth="20" :circleWidth="20"/>
          </v-card-text>
            <v-card-text class="pt-0">
            <v-list>
              <v-list-group color="purple">
                <template v-slot:activator>
                  <v-list-item-title>View props</v-list-item-title>
                </template>
              <v-list-item>
                <editor v-model="content3" @init="editorInit" lang="html" theme="chrome" width="100%" height="100"></editor>
              </v-list-item>
              </v-list-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="text-center" sm="6" cols="12">
        <v-card>
          <v-card-text class="pb-0">
            <vue-circle-control-slider dial sign="℃" :min="-60" max:="80" offKnobNumber progressColor="#FFC107" :size="300" />
          </v-card-text>
          <v-card-text class="pt-0">
            <v-list>
              <v-list-group color="purple">
                <template v-slot:activator>
                  <v-list-item-title>View props</v-list-item-title>
                </template>
              <v-list-item>
                <editor v-model="content4" @init="editorInit" lang="html" theme="chrome" width="100%" height="150"></editor>
              </v-list-item>
              </v-list-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col> 
      <v-col class="text-center" sm="6" cols="12">
        <v-card>
          <v-card-text class="pb-0">
            <vue-circle-control-slider dial  offKnobNumber progressColor="#FFC107" :size="300" knobColor="#fff" :max="220" :ms="1000" :stepSize="2" sign=" V"/>
          </v-card-text>
          <v-card-text class="pt-0">
            <v-list>
              <v-list-group color="purple">
                <template v-slot:activator>
                  <v-list-item-title>View props</v-list-item-title>
                </template>
              <v-list-item>
                <editor v-model="content5" @init="editorInit" lang="html" theme="chrome" width="100%" height="150"></editor>
              </v-list-item>
              </v-list-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col> 
    </v-row>
    <v-card>
      <v-list>
        <v-list-group color="purple">
          <template v-slot:activator>
            <v-list-item-title class="text-center">Playground</v-list-item-title>
          </template>
          <v-list-item>
            <v-row>
              <v-col cols="12" sm="6" class="text-center">
                
                <vue-circle-control-slider :key="'count_' + run"
                  :dialTextColor="cpdialTextColor"
                  :sign="cpsign"
                  :knobColor="cpknobColor"
                  :knobTextColor="cpknobTextColor"
                  :knobBorderColor="cpknobBorderColor"
                  :progressColor="cpprogressColor"
                  :circleColor="cpcircleColor"
                  :value="cpvalue"
                  :size="cpsize"
                  :dialFontSize="cpdialFontSize"
                  :min="cpmin" :max="cpmax"
                  :startAngleOffset="cpstartAngleOffset"
                  :knobBorderWidth="cpknobBorderWidth"
                  :knobRadius="cpknobRadius"
                  :progressWidth="cpprogressWidth"
                  :circleWidth="cpcircleWidth"
                  :stepSize="cpstepSize" :ms="cpms"
                  :dial="cpdial" :offKnob="cpoffKnob" :offKnobNumber="cpoffKnobNumber" :disabled="cpdisabled"
                  />
                <div class="mt-6 d-flex justify-space-around">
                  <v-btn @click="run++" color="purple" dark >try it out <v-icon rigth ></v-icon></v-btn>
                  <v-btn @click="reset" color="purple" dark>Reset</v-btn>
                </div>
                <v-color-picker mode="hexa" class="d-inline-block mt-6"></v-color-picker>
              </v-col>
              <v-col cols="6" sm="3">
                <v-list>
                  <v-list-item v-for="(p, i) in stringProps" :key="`${i}`">
                    <v-text-field :label="Object.keys(p)[0]" :value="p[Object.keys(p)[0]]" v-model="p[Object.keys(p)[0]]" ></v-text-field>
                  </v-list-item>
                   <v-list-item v-for="(p, i) in boolProps" :key="'bool_'+i">
                    <v-switch :label="Object.keys(p)[0]" v-model="p[Object.keys(p)[0]]"></v-switch>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="6" sm="3">
                <v-list>
                  <v-list-item v-for="(p, i) in numberProps" :key="`num_${i}`"  >
                    <v-text-field :label="Object.keys(p)[0]" :value="p[Object.keys(p)[0]]" v-model.number="p[Object.keys(p)[0]]" type='number'></v-text-field>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-card>
   </div>
 </v-container>
</template>

<script>
export default {
  name: 'demo',
  computed: {
    cpdialTextColor(){ return this.stringProps[0].dialTextColor },
    cpsign(){ return this.stringProps[1].sign},
    cpknobColor(){ return this.stringProps[2].knobColor},
    cpknobTextColor(){ return this.stringProps[3].knobTextColor},
    cpknobBorderColor(){ return this.stringProps[4].knobBorderColor},
    cpprogressColor(){ return this.stringProps[5].progressColor},
    cpcircleColor(){ return this.stringProps[6].circleColor},
    cpvalue(){ return this.numberProps[0].value },
    cpsize(){ return this.numberProps[1].size },
    cpdialFontSize(){ return this.numberProps[2].dialFontSize },
    cpmin(){ return this.numberProps[3].min },
    cpmax(){ return this.numberProps[4].max },
    cpstartAngleOffset(){ return this.numberProps[5].startAngleOffset },
    cpknobBorderWidth(){ return this.numberProps[6].knobBorderWidth },
    cpknobRadius(){ return this.numberProps[7].knobRadius },
    cpprogressWidth(){ return this.numberProps[8].progressWidth },
    cpcircleWidth(){ return this.numberProps[9].circleWidth },
    cpms(){ return this.numberProps[10].ms},
    cpstepSize(){ return this.numberProps[11].stepSize },
    cpdial(){ return this.boolProps[0].dial },
    cpoffKnob(){ return this.boolProps[1].offKnob },
    cpdisabled(){ return this.boolProps[2].disabled },
    cpoffKnobNumber(){ return this.boolProps[3].offKnobNumber },
    
  },
  data(){
    return{
      resetKey: 1,
      run: 1,
      boolProps: [{dial: false}, {offKnob: false}, {disabled: false}, {offKnobNumber: false}],
      stringProps: [{dialTextColor: 'black'}, {'sign':''}, {knobColor:'white'}, {knobTextColor:'black'}, {knobBorderColor:'#2196F3'},{progressColor:'#2196F3'}, {circleColor:'#9E9E9E'}],
      numberProps: [{value : 0}, {size: 200}, {dialFontSize: 50}, {min: 0}, {max: 100}, {startAngleOffset: 90}, {knobBorderWidth: 3}, {knobRadius: 18}, {progressWidth: 8}, {circleWidth: 6}, {ms: 500}, {stepSize: 1}], 
      content1: `<vue-circle-control-slider\n :startAngleOffset="0"\n progressColor="red"\n :value="25" \n/>`,
      content2: `<vue-circle-control-slider\n :value="25"\n dial\n sign="%"\n :dialFontSize="75"\n dialTextColor="red"\n :startAngleOffset="270"\n progressColor="green"\n knobTextColor="red"\n knobBorderColor="orange"\n circleColor="black"\n/>`,
      content3: `<vue-circle-control-slider\n offKnob\n :value="50"\n dial\n :progressWidth="20"\n :circleWidth="20"\n/>`,
      content4: `<vue-circle-control-slider\n sign="℃"\n :min="-60"\n :max="80"\n offKnobNumber\n :size="300"\n progressColor="#FFC107"\n/>`,
      content5: `<vue-circle-control-slider\n dial\n offKnobNumber\n :max="220"\n sign=" V"\n progressColor="#FFC107"\n :ms="1000"\n :stepSize="2"\n :size="300"\n knobColor="#fff"\n/>`,
      contentDef:`< vue-circle-control-slider />`,
    }
  },
  
  methods: {
    editorInit: function () {
        require('brace/ext/language_tools') //language extension prerequsite...
        require('brace/mode/html')                
        require('brace/mode/javascript')    //language
        require('brace/theme/chrome')
        require('brace/snippets/javascript') //snippet
    },
    reset(){
      this.boolProps = [{dial: false}, {offKnob: false}, {disabled: false}, {offKnobNumber: false}]
      this.stringProps = [{dialTextColor: 'black'}, {'sign':''}, {knobColor:'white'}, {knobTextColor:'black'}, {knobBorderColor:'#2196F3'},{progressColor:'#2196F3'}, {circleColor:'#9E9E9E'}],
      this.numberProps = [{value : 0}, {size: 200}, {dialFontSize: 50}, {min: 0}, {max: 100}, {startAngleOffset: 90}, {knobBorderWidth: 3}, {knobRadius: 18}, {progressWidth: 8}, {circleWidth: 6}, {ms: 500}, {stepSize: 1}]
    }

  },
  components: {
    editor: require('vue2-ace-editor'),
  }
}
</script>

<style lang="scss">
.v-list-item--link{
  &:hover{
    .v-list-item__title{
      color: #9c27b0;
    }
  }
  &:hover::before{
    opacity: 0.14 !important;
  }
  &:before{
    background-color: #9c27b0 !important;
  }
}
.v-text-field__details{ display: none !important;}
svg:not(:root){
  overflow: visible!important;
}
.wrapper{
  max-width: 960px;
  margin: 0 auto;
}

</style>
